/* ============================================================================
   KIKI & JOJO — Header polish JS
   - Injects a numeric count badge over the bag icon, parsed from the existing
     <p>BAG(N)</p> text. Re-syncs whenever the cart-icon-bubble re-renders.
   ============================================================================ */
(function () {
  if (window.__kjHeaderInit) return;
  window.__kjHeaderInit = true;

  var observer = null;
  var iconEl = null;

  function observe() {
    if (!observer || !iconEl) return;
    observer.observe(iconEl, { childList: true, subtree: true, characterData: true });
  }
  function unobserve() {
    if (observer) observer.disconnect();
  }

  function syncCartBadge() {
    var bubble = document.querySelector('#cart-icon-bubble .cart-count-bubble');
    if (!bubble) return;
    // Parse the BAG(N) text to find the count.
    var p = bubble.querySelector('p');
    var count = 0;
    if (p) {
      var m = (p.textContent || '').match(/\((\d+)\)/);
      if (m) count = parseInt(m[1], 10);
    }
    var badge = bubble.querySelector('.kj-cart-count-badge');
    var desired = count > 0 ? (count >= 100 ? '99+' : String(count)) : '';

    // Bail out early if nothing needs to change — prevents an infinite
    // mutation loop where our DOM writes re-trigger the MutationObserver.
    if (count <= 0 && !badge) return;
    if (count > 0 && badge && badge.textContent === desired) return;

    // Pause the observer while we mutate, then resume.
    unobserve();
    try {
      if (count <= 0) {
        if (badge) badge.remove();
      } else if (!badge) {
        badge = document.createElement('span');
        badge.className = 'kj-cart-count-badge';
        badge.textContent = desired;
        bubble.appendChild(badge);
      } else {
        badge.textContent = desired;
      }
    } finally {
      observe();
    }
  }

  function init() {
    iconEl = document.querySelector('#cart-icon-bubble');
    if (iconEl) {
      observer = new MutationObserver(function () {
        // Debounce inside an rAF so multiple consecutive mutations only trigger
        // one sync pass.
        if (window.__kjCartSyncQueued) return;
        window.__kjCartSyncQueued = true;
        requestAnimationFrame(function () {
          window.__kjCartSyncQueued = false;
          syncCartBadge();
        });
      });
      observe();
    }
    syncCartBadge();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
